/** 47-point reDevicer Verified warehouse diagnostics — category index for UI. */

export type TrustInspectionCategoryId =
  | 'display'
  | 'battery'
  | 'body'
  | 'camera'
  | 'audio'
  | 'sensors'
  | 'connectivity'
  | 'buttons'
  | 'software'

export interface TrustInspectionCategory {
  id: TrustInspectionCategoryId
  letter: string
  pointIds: readonly string[]
}

export const TRUST_INSPECTION_47: readonly TrustInspectionCategory[] = [
  {
    id: 'display',
    letter: 'A',
    pointIds: [
      'glassCracks',
      'deadPixels',
      'burnIn',
      'touchAccuracy',
      'brightnessColor',
      'scratches',
      'screenSeal',
    ],
  },
  {
    id: 'battery',
    letter: 'B',
    pointIds: ['healthPct', 'wiredCharge', 'wirelessCharge', 'heatCharging', 'swelling'],
  },
  {
    id: 'body',
    letter: 'C',
    pointIds: [
      'frameBends',
      'backDamage',
      'cameraGlass',
      'simTray',
      'looseParts',
      'cosmeticGrade',
    ],
  },
  {
    id: 'camera',
    letter: 'D',
    pointIds: ['rearClarity', 'frontClarity', 'flash', 'videoQuality', 'stabilization'],
  },
  {
    id: 'audio',
    letter: 'E',
    pointIds: ['speaker', 'earpiece', 'microphone', 'vibration'],
  },
  {
    id: 'sensors',
    letter: 'F',
    pointIds: ['proximity', 'ambientLight', 'motion', 'compass', 'biometrics', 'gps'],
  },
  {
    id: 'connectivity',
    letter: 'G',
    pointIds: ['wifi', 'bluetooth', 'cellular', 'simRecognition', 'nfc', 'usbData'],
  },
  {
    id: 'buttons',
    letter: 'H',
    pointIds: ['power', 'volume', 'chargePort', 'headphoneJack'],
  },
  {
    id: 'software',
    letter: 'I',
    pointIds: ['imei', 'activationLock', 'factoryReset', 'waterIndicator'],
  },
] as const

/** Derived from category point lists — must stay in sync with warehouse SOP. */
export const TRUST_INSPECTION_47_TOTAL = TRUST_INSPECTION_47.reduce(
  (sum, cat) => sum + cat.pointIds.length,
  0,
)

export function trustInspectionCategoryTitleKey(id: TrustInspectionCategoryId): string {
  return `trust.inspection47.cat.${id}`
}

export function trustInspectionPointKey(pointId: string): string {
  return `trust.inspection47.point.${pointId}`
}

export function trustInspectionPointNumber(
  categoryId: TrustInspectionCategoryId,
  pointIndexInCategory: number,
): number {
  let n = 0
  for (const cat of TRUST_INSPECTION_47) {
    if (cat.id === categoryId) return n + pointIndexInCategory + 1
    n += cat.pointIds.length
  }
  return pointIndexInCategory + 1
}
